import React from "react";
import { LayoutHome } from "./LayoutHome";
import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Input, notification, Splitter, Button } from "antd";
import { Image } from "react-bootstrap";

import {
  Col,
  Panel,
  Row,
  Text,
  Box,
  SelectPicker,
  Modal,
  toaster,
  Message,
} from "rsuite";
import Table from "react-bootstrap/Table";
import {
  getTurnos,
  getHorariosTurno,
  getInsumosSesion,
} from "./Services/SesionHemoServices";
import {
  getPacientesSesion,
  getDataFiltro,
  getDatospaciente,
  getAccesoVascular,
} from "./Services/HojaEnfermeria";
import {
  inicioNotaMedica,
  getDataFromHE,
  getDatosNotaMedicaView,
  saveCampo,
  saveFirmaNota,
} from "./Services/NotaMedica";
import { confApp } from "../CONF_APP";
import SignatureCanvas from "react-signature-canvas";
import { soloNumeros } from "../Utils";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import { DownloadOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

const { TextArea } = Input;

export const NotaMedicaView = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const nombreUser = JSON.parse(localStorage.getItem("auth")).nombre;
  const fechaLarga = JSON.parse(localStorage.getItem("auth")).confApp.fechas
    .fechaLarga;

  const fechaHora = JSON.parse(
    localStorage.getItem("auth"),
  ).confApp.fechas.fechaHora.toUpperCase();

  const [fecha] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas.fechaFmtUsa,
  );

  const { idSesion, idPaciente } = useParams();
  const [idNota, setIdNota] = useState(0);
  const [fechaNota, setFechaNota] = useState("");
  const [estatusNota, setEstatusNota] = useState("En Sesion");
  const [nombre, setNombre] = useState("");
  const [paciente, setPaciente] = useState("");
  const [edad, setEdad] = useState("");
  const [sexo, setSexo] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [dataTurnos, setDataTurnos] = useState([]);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [idTurno, setIdTurno] = useState(0);
  const [hora, setHora] = useState("");
  const [dataPacientes, setDataPacientes] = useState([]);
  const [filtro, setFiltro] = useState({});
  const [idFiltro, setIdFiltro] = useState("");
  const [tipoDial, setTipoDial] = useState("");
  const [pesoSeco, setPesoSeco] = useState(0);
  const [accesoVasc, setAccesoVasc] = useState("");
  const [idAccesoVasc, setIdAccesoVasc] = useState(0);
  const [pesoIngreso, setPesoIngreso] = useState(0);
  const [tiempoDial, setTiempoDial] = useState("");
  const [uf, setUf] = useState(0);
  const [perfilNa, setPerfilNa] = useState("0");
  const [perfilUf, setPerfilUf] = useState("0");
  const [heparinaBolo, setHeparinaBolo] = useState(0);
  const [infusion, setInfusion] = useState(0);
  const [dataTotalHep] = useState(confApp.VALORES_HEPARINA_BOLO);
  const [dataPErfilUfNa] = useState(confApp.PERFIL_UF_NA);
  const [dataAcido] = useState(confApp.LISTA_ACIDO);
  const [fd, setFd] = useState(0);
  const [fs, setFs] = useState(0);
  const [Na, setNa] = useState(0);
  const [acido, setAcido] = useState(0);
  const [listInsumos, setListInsumos] = useState([]);
  const [ef, setEF] = useState("");
  const [evolSesion, setEvolSesion] = useState("");
  const [estadoPac, setEstadoPac] = useState("");
  const [observa, setObserva] = useState("");
  const [uft, setUft] = useState(0);
  const [vsp, setVsp] = useState(0);
  const [pesoFinal, setPesoFinal] = useState(0);
  const [dataFirma, setDataFirma] = useState("");
  const [imageFirmaDr, setImageFirmaDr] = useState(null);
  const [loadFirmaDr, setLoadFirmaDr] = useState(null);
  const [openModalInicia, setOpenModalInicia] = useState(false);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [loadingInicio, setLoadingInicio] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [medico, setMedico] = useState("");

  const [imageFirma, setImageFirma] = useState(null);
  const [loadFirma, setLoadFirma] = useState(null);

  const handleCloseModalInicia = () => {
    setOpenModalInicia(false);
  };

	const componentRef = useRef();
  const signCanvas = useRef({});

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);
  const modal = useRef();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "5mm";
  const marginRight = "5mm";
  const marginBottom = "55mm";
  const marginLeft = "5mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Nota Médica",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const styleFont = "#4B86D1";

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const loadInsumos = async (idSes) => {
    await getInsumosSesion(idNegocio, idSes)
      .then(async (res) => {
        setListInsumos(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const clear = () => signCanvas.current.clear();

  const saveSignature = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirma(data);
      saveFirma(data);
    }
  };

  const saveFirma = async (firma) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idHoja: idNota,
      firmaEnf: firma,
      firmaPac: "",
    };
    await saveFirmaNota(data)
      .then((res) => {
        setEstatusNota(res.data);
        setOpenModalFirma(false);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const loadTurnos = async () => {
    await getTurnos(idNegocio)
      .then((res) => {
        setDataTurnos(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleObtenerDatosSesion = async () => {
    setLoadingData(true);
    await getDataFromHE(idNegocio, idSesion)
      .then((res) => {
        if (res === "") {
          errorNotificaction(
            "Datos HE",
            "No existe información de la Hoja de Enfermería.",
          );
        }
        setUft(res.uft);
        setVsp(res.vsp);
        setPesoFinal(res.pesoFinal);
        setEstatusNota(res.estatus);
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const maskTime = (value, opc) => {
    if (opc === "tiempoDial") {
      setTiempoDial(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
  };

  const handleFocus = (event) => event.target.select();

  const handleEF = (e) => {
    setEF(e.target.value);
  };

  const handleEvolSesion = (e) => {
    setEvolSesion(e.target.value);
  };

  const handleEstadoPac = (e) => {
    setEstadoPac(e.target.value);
  };

  const handleOpenModalFirma = () => {
    if (estatusNota === "Cerrada") {
      setDataFirma(`Firma del Médico`);
      setOpenModalFirma(true);
    } else {
      errorNotificaction(
        "Validación de cierre",
        `No es posible abrir el modal de firma, revise que toda la información este completa.`,
      );
    }
  };

  const loadInicioNota = async () => {
    await getDatosNotaMedicaView(idNegocio, idSesion)
      .then(async (res) => {
        setIdNota(res.idNota);
        setEstatusNota(res.estatus);
        setFechaNota(res.fecha);
        setNombre(res.paciente);
        setSexo(res.genero);
        let _fecha = res.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(res.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
        } else {
          setEdad(0);
        }
        setDiagnostico(res.diagnostico);
        setPesoSeco(res.pesoSeco);

        setPesoIngreso(res.pesoInicio);
        setTiempoDial(res.tiempo);
        setUf(res.uf);
        setFd(res.fd);
        setFs(res.fs);
        setNa(res.Na);
        setAcido(res.acido);
        setPerfilNa(String(res.perfilNa));
        setPerfilUf(String(res.perfilUf));
        setHeparinaBolo(String(res.hepaBolo));
        setInfusion(String(res.infusion));
        setEvolSesion(res.evol);
        setEF(res.explora);
        setEstadoPac(res.estadoPac);
        setUft(res.uft);
        setVsp(res.vsp);
        setPesoFinal(res.pesoFinal);
        setObserva(res.observa);
        setLoadFirma(res.firma);
        setFiltro(res.filtro);
        setMedico(res.medico);

        setEstatusNota(res.estatus);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadInicioNota();
    }
  }, []);

  return (
    <>
      <title>Nota Médica Vista</title>
      <div ref={componentRef}>
        <Image
          src={`/Images/Negocios/${idNegocio}/cornerImageHoja.png`}
          style={{
            width: "450px",
            position: "absolute",
            right: "0%",
            top: "0%",
            zIndex: "-1",
          }}
        />
        <div
          style={{
            marginLeft: "100px",
            marginTop: "50px",
            marginRight: "100px",
          }}
        >
          <Panel>
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-3">
                <Image
                  src={`/Images/Negocios/${idNegocio}/Logo.png`}
                  height={"80ox"}
                />
              </div>
              <div className="text-center col-lg-5 col-md-5 col-sm-5">
                <br></br>
                <Text size="lg" weight="bold" color={styleFont} style={{ cursor: "pointer" }} onClick={() => handlePrint()}>
                  INDICACIONES MEDICAS Y NOTA MEDICA
                </Text>
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1"></div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <br></br>
                <Box
                  mb={2}
                  bd="1px solid var(--rs-border-primary)"
                  rounded="lg"
                  style={{ padding: "5px" }}
                >
                  <Text size={"lg"} weight="semibold" color={styleFont}>
                    Folio No. {idNota}
                  </Text>
                </Box>
              </div>
            </div>
          </Panel>
          <Row>
            <Col span={24}>
              <Table bordered style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "10%", color: styleFont }}>NOMBRE:</th>
                    <th style={{ width: "70%", color: styleFont }}>
                      {nombre.toUpperCase()}
                    </th>
                    <th style={{ width: "10%", color: styleFont }}>EDAD:</th>
                    <th
                      style={{
                        width: "30%",
                        textAlign: "center",
                        color: styleFont,
                      }}
                    >
                      {edad} años
                    </th>
                  </tr>
                  <tr>
                    <th style={{ color: styleFont }}>DIAGNÓSTICO:</th>
                    <th style={{ color: styleFont }}>
                      <Text color={styleFont}>{diagnostico}</Text>
                    </th>
                    <th style={{ color: styleFont }}>SEXO:</th>
                    <th
                      style={{
                        width: "30%",
                        textAlign: "center",
                        color: styleFont,
                      }}
                    >
                      {sexo}
                    </th>
                  </tr>
                </thead>
              </Table>
            </Col>
          </Row>
          <Panel bordered>
            <Row>
              <Col span={24}>
                <Splitter style={{ overflowX: "hidden" }}>
                  <Splitter.Panel
                    style={{ padding: "2px", overflowX: "hidden" }}
                    defaultSize="50%"
                    min="40%"
                    max="80%"
                  >
                    <Table bordered style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th
                            colSpan={4}
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: styleFont,
                            }}
                          >
                            INDICACIONES MÉDICAS
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>FECHA Y HORA:</th>
                          <th
                            colSpan={3}
                            style={{ textAlign: "center", color: styleFont }}
                          >
                            {fechaNota.toUpperCase()}
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>FILTRO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            {filtro.clasifica}
                          </th>
                          <th style={{ color: styleFont }}>P. SECO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{pesoSeco}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>ACCESO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{accesoVasc}</Text>
                          </th>
                          <th style={{ color: styleFont }}>P. INICIO</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{pesoIngreso}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>TIEMPO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{tiempoDial}</Text>
                          </th>
                          <th style={{ color: styleFont }}>UF:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{uf}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>FD:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{fd}</Text>
                          </th>
                          <th style={{ color: styleFont }}>PERFIL UF:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{perfilUf}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>FS:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{fs}</Text>
                          </th>
                          <th style={{ color: styleFont }}>PERFIL Na:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{perfilNa}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>HEPARINA BOLO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{heparinaBolo}</Text>
                          </th>
                          <th style={{ color: styleFont }}>NA:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{Na}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ color: styleFont }}>HEP INFUSIÓN:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{infusion}</Text>
                          </th>
                          <th style={{ color: styleFont }}>ACIDO:</th>
                          <th style={{ textAlign: "center", color: styleFont }}>
                            <Text color={styleFont}>{acido}</Text>
                          </th>
                        </tr>
                        <tr>
                          <th
                            colspan={4}
                            style={{
                              textAlign: "center",
                              fontSize: "18px",
                              color: styleFont,
                            }}
                          >
                            Medicamentos
                          </th>
                        </tr>
                      </thead>
                      {listInsumos.length > 0 ? (
                        <tbody>
                          {listInsumos.map((item, index) => {
                            return (
                              <tr key={`row-${index}`}>
                                <td style={{ textAlign: "center" }}>
                                  {item.cantidad}
                                </td>
                                <td colspan={2} style={{ color: styleFont }}>
                                  {item.insumo}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.hora}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        ""
                      )}
                    </Table>
                  </Splitter.Panel>
                  <Splitter.Panel
                    style={{ padding: "2px", overflowX: "hidden" }}
                    defaultSize="50%"
                    min="40%"
                    max="80%"
                  >
                    <Table bordered style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th
                            colSpan={7}
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: styleFont,
                            }}
                          >
                            NOTA MÉDICA
                          </th>
                        </tr>
                        <tr>
                          <th
                            style={{
                              verticalAlign: "top",
                              fontSize: "16px",
                              width: "40%",
                              color: styleFont,
                            }}
                          >
                            <u>EF a su ingreso:</u>
                          </th>
                          <th colspan={6}>
                            <TextArea
                              readOnly
                              rows={4}
                              value={ef}
                              style={{ color: styleFont }}
                              variant="underlined"
                              color={styleFont}
                            />
                          </th>
                        </tr>
                        <tr>
                          <th
                            style={{ verticalAlign: "top", fontSize: "16px" }}
                          >
                            <u style={{ color: styleFont }}>
                              Evolución en la sesión de hemodiálisis:
                            </u>
                          </th>
                          <th colspan={6}>
                            <TextArea
                              readOnly
                              rows={4}
                              value={evolSesion}
                              variant="underlined"
                              style={{ color: styleFont }}
                              color={styleFont}
                            />
                          </th>
                        </tr>
                        <tr>
                          <th
                            style={{ verticalAlign: "top", fontSize: "16px" }}
                          >
                            <u style={{ color: styleFont }}>
                              Estado del paciente a su egreso:
                            </u>
                          </th>
                          <th colspan={6}>
                            <TextArea
                              readOnly
                              rows={4}
                              value={estadoPac}
                              variant="underlined"
                              color={styleFont}
                              style={{ color: styleFont }}
                            />
                          </th>
                        </tr>
                        <tr style={{ height: "70px", verticalAlign: "center" }}>
                          <th
                            style={{
                              textAlign: "center",
                              verticalAlign: "center",
                            }}
                          ></th>
                          <th
                            style={{
                              fontSize: "16px",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            UFT:
                          </th>
                          <th
                            style={{
                              textAlign: "center",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            {uft}
                          </th>
                          <th
                            style={{
                              fontSize: "16px",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            VSP:
                          </th>
                          <th
                            style={{
                              textAlign: "center",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            {vsp}
                          </th>
                          <th
                            style={{
                              fontSize: "16px",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            <u>Peso al final:</u>
                          </th>
                          <th
                            style={{
                              textAlign: "center",
                              verticalAlign: "top",
                              color: styleFont,
                            }}
                          >
                            {pesoFinal}
                          </th>
                        </tr>
                      </thead>
                    </Table>
                  </Splitter.Panel>
                </Splitter>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Text weight="semibold" color={styleFont}>
                  Observaciones:
                </Text>
                <TextArea
                  readOnly
                  rows={2}
                  value={observa}
                  variant="underlined"
                  color={styleFont}
                />
              </Col>
            </Row>
            <div className="row mb-1">
              {imageFirmaDr && (
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <img
                    src={imageFirmaDr}
                    alt="signature"
                    style={{ height: "200px", width: "auto", padding: "10px" }}
                  />
                </div>
              )}
              {loadFirmaDr && imageFirmaDr === null && (
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <img
                    src={`Unidades/${idNegocio}/Sesiones/${idSesion}/${idNota}/${loadFirmaDr}`}
                    alt="signature"
                    style={{ height: "200px", width: "auto", padding: "10px" }}
                  />
                </div>
              )}
            </div>
            <div className="row">
              <br></br>
            </div>
            <div className="row mb-1">
              {imageFirma && (
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <img
                    src={imageFirma}
                    alt="signature"
                    style={{ height: "200px", width: "auto", padding: "10px" }}
                  />
                </div>
              )}
              {loadFirma && imageFirma === null && (
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <img
                    src={`Unidades/${idNegocio}/Sesiones/${idSesion}/FirmaNotaMedica/${loadFirma}`}
                    alt="signature"
                    style={{ height: "200px", width: "auto", padding: "10px" }}
                  />
                </div>
              )}
            </div>
            <div className="row">
              <div className="text-center col-lg-6 col-md-6">
                <Text variant="secondary" color={styleFont}>
                  {medico.toUpperCase()}
                </Text>
                <p
                  style={{
                    margin: "0",
                    borderTopStyle: "solid",
                    borderWidth: "0.1em",
                    borderColor: styleFont,
                  }}
                >
                  <Text weight="semibold" color={styleFont}>
                    Firma del médico responsable
                  </Text>
                </p>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </>
  );
};
